'use client';

import { INavListItem } from '@/api/types/public';
import MagicJump from '@/components/MagicJump';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { setSession } from '@/utils/tools';
import Image from '@/components/Image';
import { InView } from 'react-intersection-observer';
import styles from './index.module.scss';

interface ImageNavProps {
  item: INavListItem;
  firstLevelIndex: number; // 所属的一级菜单索引
  firstLevelTitle: string; // 一级菜单标题
  isDarkMode?: boolean;
  // secondLevelIndex: number; // 所属的二级菜单索引
}

const ImageNav = ({
  item,
  firstLevelIndex,
  firstLevelTitle,
  isDarkMode = false,
}: ImageNavProps) => {
  const setIsOpenSideNav = useStore((state) => state.setIsOpenSideNav);
  const { trackEvent } = useReporting();
  const { cnName } = useRouteMetadata();
  const isMobileScreen = useStore((state) => state.isMobileScreen);

  if (!item.content) return null;

  const handleBeforeJump = () => {
    setSession('zl_goodsListEnterPageScene', '全局导航');
    setIsOpenSideNav(false);
    // TODO: 这种乱七八糟的埋点事件真的是无语，同样的功能，非要折腾两套事件名称！！同时还有其他几个也是一样
    trackEvent(
      {
        eventName: isMobileScreen ? 'SideNavBarMkt_Click' : 'TopNavigationMkt_Click',
        properties: {
          page_name: cnName,
          url_path: window.location.href,
          tab_name: firstLevelTitle, // 一级菜单标题
          tab_index: firstLevelIndex, // 一级菜单索引
          // TODO:都没见过这个字段？
          pits_index: (item as any).imageTemplateIndex || 0,
          pits_title: (item.content as any).title,
        },
      },
      [ProviderType.SENSORS],
    );
  };

  const handleInView = (inView: boolean) => {
    if (inView && isMobileScreen) {
      trackEvent(
        {
          eventName: 'SideNavBarMkt_Exp',
          properties: {
            page_name: cnName,
            url_path: window.location.href,
            tab_name: firstLevelTitle,
            pits_index: (item as any).imageTemplateIndex || 0,
            pits_title: (item.content as any).title,
            tab_index: firstLevelIndex,
          },
        },
        [ProviderType.SENSORS],
      );
    }
  };

  const jumpTarget = {
    jump_type: item.content.jump_type || 0,
    Jump_target: item.content.Jump_target || '',
    product_group: {
      id: item.content.product_group?.id,
      path: (item.content.product_group as any)?.path,
    },
    sku: {
      shop_sku: Array.isArray(item.content.sku)
        ? item.content.sku[0]
        : (item.content.sku as any)?.shop_sku,
    },
    crowd_recommend: {
      id: (item.content as any).crowd_recommend?.id,
    },
  };

  return (
    <InView
      className={`image-nav ${isDarkMode ? 'text-[#ffffff] bg-[#131415]' : 'text-[#282828] bg-white'}  py-[10px] px-[14px] pb-[14px] ${styles.imageNavPc}`}
      onChange={handleInView}
      triggerOnce
    >
      <MagicJump className="item block" item={jumpTarget} onBeforeJump={handleBeforeJump}>
        {(item.content as any).jump_image && (
          <Image
            src={(item.content as any).jump_image}
            alt={String((item.content as any).title || 'glasses')}
            className="w-full max-w-[217px] block mx-auto"
            width={300}
            height={200}
          />
        )}
        {(item.content as any).title && (
          <p className="text-center text-[12px] lg:text-[16px] lg:mt-[12px]">
            {(item.content as any).title}
          </p>
        )}
      </MagicJump>
    </InView>
  );
};

export default ImageNav;
